import React from 'react';
import styled from 'styled-components';

import { Tabs, HorizontalTab } from 'components/core';
import useTranslation from 'hooks/use-translation';
import { useDutchiePay } from 'src/payments/hooks';
import { ARIA_ROLES } from 'shared/constants';
import { TabLink } from 'src/components/core/tabs/tab-link';
import ROUTES from 'src/routes';

const { ACCOUNT, PREFERENCES, ORDERS, BANK_ACCOUNT } = ROUTES;
const ANCHOR_COMPONENT = `a`;

export default function AccountTopNavBar(props) {
  const { selectedTab } = props;
  const { t } = useTranslation();
  const { shouldShowBankAccountTab } = useDutchiePay();

  return (
    <TopNavBarContainer>
      <Tabs scrollButtons='off' selectionFollowsFocus value={selectedTab} variant='scrollable'>
        {shouldShowBankAccountTab && (
          <TabLink value={BANK_ACCOUNT} href={BANK_ACCOUNT}>
            <HorizontalTab
              id='account-tab-bank-account'
              data-testid='account-tab-bank-account'
              aria-controls='account-tab-panel-dutchie-pay'
              aria-selected={selectedTab === BANK_ACCOUNT}
              component={ANCHOR_COMPONENT}
              label={t('accountPage.bankAccount', 'Bank Account')}
              role={ARIA_ROLES.TAB}
              value={BANK_ACCOUNT}
            />
          </TabLink>
        )}
        <TabLink value={ACCOUNT} href={ACCOUNT}>
          <HorizontalTab
            id='account-tab-my-account'
            data-testid='account-tab-my-account'
            aria-controls='account-tab-panel-my-account'
            aria-selected={selectedTab === ACCOUNT}
            component={ANCHOR_COMPONENT}
            label={t('accountPage.accountDetails', 'Account Details')}
            role={ARIA_ROLES.TAB}
            value={ACCOUNT}
          />
        </TabLink>
        <TabLink value={PREFERENCES} href={PREFERENCES}>
          <HorizontalTab
            id='account-tab-preferences'
            data-testid='account-tab-preferences'
            aria-controls='account-tab-panel-preferences'
            aria-selected={selectedTab === PREFERENCES}
            component={ANCHOR_COMPONENT}
            label={t('accountPage.preferences', 'Preferences')}
            role={ARIA_ROLES.TAB}
            value={PREFERENCES}
          />
        </TabLink>
        <TabLink value={ORDERS} href={ORDERS}>
          <HorizontalTab
            id='account-tab-orders'
            data-testid='account-tab-orders'
            aria-controls='account-tab-panel-orders'
            aria-selected={selectedTab === ORDERS}
            component={ANCHOR_COMPONENT}
            label={t('accountPage.orders', 'Orders')}
            role={ARIA_ROLES.TAB}
            value={ORDERS}
          />
        </TabLink>
      </Tabs>
    </TopNavBarContainer>
  );
}

const TopNavBarContainer = styled.div`
  color: ${({ theme }) => theme.colors.grey[30]};
`;
